// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasCircleExclamation: CreateIconOptions = {
  "displayName": "FASCircleExclamation",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
};
